import { createAPIModule } from '@/api/utils';

export default createAPIModule({
  endpoint: 'revisiones',
  getAllParams: ({
    from, include, page, completas, resueltas, perPage, search, to,
  }) => ({
    'filter[encargo.numero_encargo]': search,
    'filter[cerrada]': completas,
    'filter[fecha_hora_resolucion]': resueltas,
    from,
    include,
    page,
    per_page: perPage,
    to,
  }),
});
